import { Translator } from '../Translator';
import { isCordova } from './platform';

const availableLanguages = require('resources/languages.json');

export const startsWithLangCode = (pathname) =>
  availableLanguages.find((langCode) => pathname.startsWith(`/${langCode}/`));

const getNewPath = (pathname: string, langCode: string) => {
  const langCodeInPath = startsWithLangCode(pathname);

  if (langCode !== 'en' && langCodeInPath !== langCode) {
    let newPathname = pathname;

    if (langCodeInPath) {
      newPathname = newPathname.substring(3);
    }

    newPathname = `/${langCode}${newPathname}`;
    return newPathname;
  }

  if (langCode === 'en' && langCodeInPath) {
    const newPathname = `${pathname.substring(3)}`;
    return newPathname;
  }
  return pathname;
};

export const generatePathname = (pathname: string) =>
  generatePathnameWithLangCode(pathname, Translator.getLanguageCode());

export const generatePathnameWithLangCode = (
  pathname: string,
  langCode: string,
) => {
  const newPathname = getNewPath(pathname, langCode);
  return newPathname.endsWith('/') ? newPathname : `${newPathname}/`;
};

export const setCorrectLocaleParam = (props): boolean => {
  const newPathname = generatePathnameWithLangCode(
    props.location.pathname,
    Translator.getLanguageCode(),
  );

  if (newPathname === props.location.pathname) {
    return false;
  }

  props.history.replace({
    ...props.location,
    pathname: newPathname,
  });
  return true;
};

export const convertPathToHashBased = (props) => {
  if (isCordova()) {
    return;
  }
  const origin = window.location.origin;
  const href = window.location.href;
  const path = href.substr(origin.length, href.length - 1);
  const hashParts = path.split('#');
  if (hashParts.length > 1) {
    const browserBasedPath = hashParts[0];
    const hashBasedPath = hashParts[1];
    if (hashBasedPath === '/') {
      props.history.replace({
        ...props.location,
        pathname: browserBasedPath,
      });
      window.location.href = `${window.location.origin}#${browserBasedPath}`;
    }
  }
};

export const getPath = () => {
  return (
    window.location.pathname + window.location.search + window.location.hash
  );
};
